import * as api from '../../../clients/vorlagen';

import {Action} from '@ngrx/store';

export const POST_DOKUMENT_LESE_BERECHTIGUNG_ENTFERNEN_MULTI = '[VorlagenModul] PostDokumentLeseBerechtigungEntfernenMulti laden';
export const POST_DOKUMENT_LESE_BERECHTIGUNG_ENTFERNEN_MULTI_AUSFUEHREN = '[VorlagenModul] PostDokumentLeseBerechtigungEntfernenMulti ausführen';
export const POST_DOKUMENT_LESE_BERECHTIGUNG_ENTFERNEN_MULTI_ERFOLGREICH = '[VorlagenModul] PostDokumentLeseBerechtigungEntfernenMulti laden erfolgreich';
export const POST_DOKUMENT_LESE_BERECHTIGUNG_ENTFERNEN_MULTI_FEHLER = '[VorlagenModul] PostDokumentLeseBerechtigungEntfernenMulti Ladefehler';
export const POST_DOKUMENT_LESE_BERECHTIGUNG_ENTFERNEN_MULTI_NICHT_AUSGEFUEHRT = '[VorlagenModul] PostDokumentLeseBerechtigungEntfernenMulti nicht ausgeführt (evtl. Offline)';


export class PostDokumentLeseBerechtigungEntfernenMultiAction implements Action {
    readonly type = POST_DOKUMENT_LESE_BERECHTIGUNG_ENTFERNEN_MULTI;
        constructor(public dokumentBerechtigungRolleMultiRequest: api.DokumentBerechtigungRolleMultiRequest, public optPayload: any = null) {}
    }
export class PostDokumentLeseBerechtigungEntfernenMultiAusfuehrenAction implements Action {
    readonly type = POST_DOKUMENT_LESE_BERECHTIGUNG_ENTFERNEN_MULTI_AUSFUEHREN;
        constructor(public dokumentBerechtigungRolleMultiRequest: api.DokumentBerechtigungRolleMultiRequest, public optPayload: any = null) {}
    }
export class PostDokumentLeseBerechtigungEntfernenMultiErfolgreichAction implements Action {
    readonly type = POST_DOKUMENT_LESE_BERECHTIGUNG_ENTFERNEN_MULTI_ERFOLGREICH;
        constructor(public payload: api.DokumentIdentifier, public dokumentBerechtigungRolleMultiRequest: api.DokumentBerechtigungRolleMultiRequest, public optPayload: any = null) {}
    }
export class PostDokumentLeseBerechtigungEntfernenMultiFehlerAction implements Action {
    readonly type = POST_DOKUMENT_LESE_BERECHTIGUNG_ENTFERNEN_MULTI_FEHLER;
        constructor(public payload: any, public dokumentBerechtigungRolleMultiRequest: api.DokumentBerechtigungRolleMultiRequest, public optPayload: any = null) {}
    }
export class PostDokumentLeseBerechtigungEntfernenMultiNichtAusgefuehrtAction implements Action {
    readonly type = POST_DOKUMENT_LESE_BERECHTIGUNG_ENTFERNEN_MULTI_NICHT_AUSGEFUEHRT;
        constructor(public optPayload: any = null) {}
    }
    

export type VorlagenCommandDokumentLeseBerechtigungEntfernenMultiActions =
    PostDokumentLeseBerechtigungEntfernenMultiAction
    | PostDokumentLeseBerechtigungEntfernenMultiAusfuehrenAction
    | PostDokumentLeseBerechtigungEntfernenMultiErfolgreichAction
    | PostDokumentLeseBerechtigungEntfernenMultiFehlerAction
    | PostDokumentLeseBerechtigungEntfernenMultiNichtAusgefuehrtAction
    ;
